import {MenuItem} from '@/store/types'
import {RouteConfig} from 'vue-router'

/**
 * Rutas para las pantallas de administración del blog
 */
export function routes (): RouteConfig[] {
    return [
        {
            name: 'blog.post-list',
            path: '/blog/publicaciones',
            component: () => import('@/modules/blog/components/PostList.vue'),
            meta: {
                toolbarTitle: 'Publicaciones del blog',
                authRequired: true,
                module: 'blog.posts',
                vuex: {
                    loadModules: ['blog', 'i18n'],
                },
            },
        },
        {
            name: 'blog.post',
            path: '/blog/publicacion/:id',
            component: () => import('@/modules/blog/components/Post.vue'),
            meta: {
                toolbarTitle: 'Ver/Editar publicación',
                authRequired: true,
                module: 'blog.post',
                vuex: {
                    loadModules: ['blog', 'i18n', 'seo', 'cms', 'media'],
                    dispatch: ['i18n/loadWorldLocales'],
                },
            },
        },
        {
            name: 'blog.tags',
            path: '/blog/etiquetas',
            component: () => import('@/modules/blog/components/tag/TagList.vue'),
            meta: {
                toolbarTitle: 'Etiquetas del blog',
                authRequired: true,
                module: 'blog.posts',
                vuex: {
                    loadModules: ['blog'],
                },
            },
        },
    ]
}

export function menu (): MenuItem[] {
    return [
        {
            title: 'Blog',
            icon: 'mdi-forum',
            module: 'blog',
            permission: '@/blog/admin/administration_access',
            requireAuthorization: true,
            children: [
                {
                    title: 'Publicaciones',
                    icon: 'mdi-receipt',
                    routeName: 'blog.post-list',
                    permission: '@/blog/admin/posts/post_list_access',
                    requireAuthorization: true,
                },
                {
                    title: 'Etiquetas',
                    icon: 'mdi-tag-outline',
                    routeName: 'blog.tags',
                    permission: '@/blog/admin/tags/administration_access',
                    requireAuthorization: true,
                },
            ],
        },
    ]
}
